//
// Copyright 2026 DXOS.org
//
import * as Rpc from '@effect/rpc/Rpc';
import * as RpcGroup from '@effect/rpc/RpcGroup';
import * as Context from 'effect/Context';
import * as Schema from 'effect/Schema';
import { protoMessage, serviceError } from './service-rpc.js';
import { mutableArray } from './service-schemas.js';
//
// RPC message schemas.
//
export const QueryDevicesResponse = Schema.Struct({
    devices: Schema.optional(mutableArray(protoMessage('dxos.client.services.Device'))),
});
/**
 * Effect RPC definitions for `dxos.client.services.DevicesService`.
 * Service-only payloads use Effect schemas; shared proto types remain protobuf-encoded on the wire.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('updateDevice', {
    payload: protoMessage('dxos.halo.credentials.DeviceProfileDocument'),
    success: protoMessage('dxos.client.services.Device'),
    error: serviceError,
}), Rpc.make('queryDevices', {
    success: QueryDevicesResponse,
    error: serviceError,
    stream: true,
})).prefix('DevicesService.') {
}
/**
 * Effect service tag for the `DevicesService` RPC handlers.
 */
export class Tag extends Context.Tag('@dxos/protocols/rpc/DevicesService')() {
}
//# sourceMappingURL=DevicesService.js.map